"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core"),
    n = require("react-dom");

function r(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var a,
    o = r(e),
    _i = function i() {
  return (_i = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var a in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    c = function c() {
  return o.createElement(t.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M7.5,19.499h9 M7.5,16.499h9 M5.5,16.5h-3c-1.103-0.003-1.997-0.897-2-2v-6c0.003-1.103,0.897-1.997,2-2h19\n            c1.103,0.003,1.997,0.897,2,2v6c-0.003,1.103-0.897,1.997-2,2h-3\n            M5.5,4.5v-4h9.586c0.265,0,0.52,0.105,0.707,0.293l2.414,2.414\n            C18.395,3.394,18.5,3.649,18.5,3.914V4.5\n            M18.5,22.5c0,0.552-0.448,1-1,1h-11c-0.552,0-1-0.448-1-1v-9h13V22.5z\n            M3.5,8.499\n            c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S2.948,8.499,3.5,8.499z\n            M14.5,0.499v4h4"
  }));
},
    u = {
  left: 0,
  top: 8
},
    l = function l(e) {
  var n = e.enableShortcuts,
      r = e.onClick,
      a = o.useContext(t.LocalizationContext),
      i = a && a.print ? a.print.print : "Print",
      l = n ? t.isMac() ? "Meta+p" : "Ctrl+p" : "";
  return o.createElement(t.Tooltip, {
    ariaControlsSuffix: "print",
    position: t.Position.BottomCenter,
    target: o.createElement(t.MinimalButton, {
      ariaKeyShortcuts: l,
      ariaLabel: i,
      onClick: r
    }, o.createElement(c, null)),
    content: function content() {
      return i;
    },
    offset: u
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


!function (e) {
  e.Inactive = "Inactive", e.Preparing = "Preparing", e.Cancelled = "Cancelled", e.Ready = "Ready";
}(a || (a = {}));

var s = function s(e) {
  var t = e.children,
      n = e.enableShortcuts,
      r = e.store;
  return (t || l)({
    enableShortcuts: n,
    onClick: function onClick() {
      r.update("printStatus", a.Preparing);
    }
  });
},
    p = function p(e) {
  var n = e.numLoadedPages,
      r = e.numPages,
      a = e.onCancel,
      i = o.useContext(t.LocalizationContext),
      c = Math.floor(100 * n / r);
  return o.createElement("div", {
    className: "rpv-print__progress"
  }, o.createElement("div", {
    className: "rpv-print__progress-body"
  }, o.createElement("div", {
    className: "rpv-print__progress-message"
  }, i && i.print ? i.print.preparingDocument : "Preparing document ..."), o.createElement("div", {
    className: "rpv-print__progress-bar"
  }, o.createElement(t.ProgressBar, {
    progress: c
  })), o.createElement(t.Button, {
    onClick: a
  }, i && i.print ? i.print.cancel : "Cancel")));
},
    d = function d(e) {
  var t = e.canvas,
      n = e.page,
      r = e.pageHeight,
      a = e.pageWidth,
      i = e.rotation,
      c = e.onLoad,
      u = o.useRef(),
      l = o.useState(""),
      s = l[0],
      p = l[1];
  return o.useEffect(function () {
    var e = u.current;
    e && e.cancel();
    var o = 150 / 72;
    t.height = Math.floor(r * o), t.width = Math.floor(a * o);
    var c = t.getContext("2d");
    c.save(), c.fillStyle = "rgb(255, 255, 255)", c.fillRect(0, 0, t.width, t.height), c.restore();
    var l = n.getViewport({
      rotation: i,
      scale: 1
    });
    u.current = n.render({
      canvasContext: c,
      intent: "print",
      transform: [o, 0, 0, o, 0, 0],
      viewport: l
    }), u.current.promise.then(function () {
      "toBlob" in t ? t.toBlob(function (e) {
        p(URL.createObjectURL(e));
      }) : p(t.toDataURL());
    }, function () {});
  }, []), s && o.createElement("div", {
    className: "rpv-print__page"
  }, o.createElement("img", {
    src: s,
    onLoad: function onLoad() {
      return c();
    }
  }));
},
    m = function m(e) {
  var t = e.canvas,
      n = e.doc,
      r = e.pageHeight,
      a = e.pageIndex,
      i = e.pageWidth,
      c = e.rotation,
      u = e.onLoad,
      l = o.useState({
    height: r,
    page: null,
    viewportRotation: 0,
    width: i
  }),
      s = l[0],
      p = l[1],
      m = s.page,
      g = s.height,
      f = s.width,
      v = Math.abs(c) % 180 == 0;
  o.useEffect(function () {
    n.getPage(a + 1).then(function (e) {
      var t = e.getViewport({
        scale: 1
      });
      p({
        height: t.height,
        page: e,
        viewportRotation: t.rotation,
        width: t.width
      });
    });
  }, []);
  var h = (c + s.viewportRotation) % 360;
  return m && o.createElement(d, {
    canvas: t,
    page: m,
    pageHeight: v ? g : f,
    pageWidth: v ? f : g,
    rotation: h,
    onLoad: u
  });
},
    g = function g(e) {
  var t = e.doc,
      r = e.numLoadedPages,
      i = e.pageHeight,
      c = e.pageWidth,
      u = e.printStatus,
      l = e.rotation,
      s = e.onCancel,
      p = e.onLoad,
      d = o.useMemo(function () {
    return document.createElement("canvas");
  }, []),
      g = o.useMemo(function () {
    var e = document.createElement("div");
    return e.classList.add("rpv-print__zone"), document.body.appendChild(e), e;
  }, []);
  return o.useEffect(function () {
    u === a.Ready && (document.documentElement.classList.add("rpv-print__html-printing"), document.body.classList.add("rpv-print__body-printing"), window.print());

    var e = function e() {
      u === a.Ready && (document.documentElement.classList.remove("rpv-print__html-printing"), document.body.classList.remove("rpv-print__body-printing"), g.parentElement && g.parentElement.removeChild(g), d.height = 0, d.width = 0, document.removeEventListener("mousemove", e), s());
    };

    return document.addEventListener("mousemove", e), function () {
      return document.removeEventListener("mousemove", e);
    };
  }, [u]), n.createPortal(o.createElement(o.Fragment, null, Array(Math.min(r + 1, t.numPages)).fill(0).map(function (e, n) {
    return o.createElement(m, {
      key: n,
      canvas: d,
      doc: t,
      pageHeight: i,
      pageIndex: n,
      pageWidth: c,
      rotation: l,
      onLoad: p
    });
  }), o.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "@page { size: " + c + "pt " + i + "pt }"
    }
  })), g);
},
    f = function f(e) {
  var t = e.doc,
      n = e.pageHeight,
      r = e.pageWidth,
      i = e.rotation,
      c = e.store,
      u = o.useState(a.Inactive),
      l = u[0],
      s = u[1],
      d = o.useState(0),
      m = d[0],
      f = d[1],
      v = function v() {
    f(0), s(a.Inactive);
  },
      h = function h(e) {
    return s(e);
  };

  return o.useEffect(function () {
    return c.subscribe("printStatus", h), function () {
      c.unsubscribe("printStatus", h);
    };
  }, []), o.createElement(o.Fragment, null, l === a.Preparing && o.createElement(p, {
    numLoadedPages: m,
    numPages: t.numPages,
    onCancel: v
  }), (l === a.Preparing || l === a.Ready) && m <= t.numPages && o.createElement(g, {
    doc: t,
    numLoadedPages: m,
    pageHeight: n,
    pageWidth: r,
    printStatus: l,
    rotation: i,
    onCancel: v,
    onLoad: function onLoad() {
      var e = m + 1;
      e <= t.numPages && (f(e), e === t.numPages && s(a.Ready));
    }
  }));
},
    v = function v(e) {
  var n = e.onClick,
      r = o.useContext(t.LocalizationContext),
      a = r && r.print ? r.print.print : "Print";
  return o.createElement(t.MenuItem, {
    icon: o.createElement(c, null),
    onClick: n
  }, a);
},
    h = function h(e) {
  var n = e.containerRef,
      r = e.store,
      i = function i(e) {
    if (!e.shiftKey && !e.altKey && "p" === e.key && (t.isMac() ? e.metaKey : e.ctrlKey)) {
      var o = n.current;
      o && document.activeElement && o.contains(document.activeElement) && (e.preventDefault(), r.update("printStatus", a.Preparing));
    }
  };

  return o.useEffect(function () {
    if (n.current) return document.addEventListener("keydown", i), function () {
      document.removeEventListener("keydown", i);
    };
  }, [n.current]), o.createElement(o.Fragment, null);
};

exports.PrintIcon = c, exports.printPlugin = function (e) {
  var n = o.useMemo(function () {
    return Object.assign({}, {
      enableShortcuts: !0
    }, e);
  }, []),
      r = o.useMemo(function () {
    return t.createStore({
      printStatus: a.Inactive
    });
  }, []),
      c = function c(e) {
    return o.createElement(s, _i({
      enableShortcuts: n.enableShortcuts
    }, e, {
      store: r
    }));
  };

  return {
    renderViewer: function renderViewer(e) {
      var t = e.slot,
          a = {
        children: o.createElement(o.Fragment, null, n.enableShortcuts && o.createElement(h, {
          containerRef: e.containerRef,
          store: r
        }), o.createElement(f, {
          doc: e.doc,
          pageHeight: e.pageHeight,
          pageWidth: e.pageWidth,
          rotation: e.rotation,
          store: r
        }), t.children)
      };
      return _i(_i({}, t), a);
    },
    Print: c,
    PrintButton: function PrintButton() {
      return o.createElement(c, null, function (e) {
        return o.createElement(l, _i({}, e));
      });
    },
    PrintMenuItem: function PrintMenuItem(e) {
      return o.createElement(c, null, function (t) {
        return o.createElement(v, {
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    }
  };
};